<!--招投标-->
<template>
  <div class="bidding-container">
    <div class="bidding-content">
      <div class="bidding-info" v-for="bidding of biddingData" @click="details(bidding)">
        <p><span class="adRegions">【{{bidding.adRegions}}】</span><span class="title">{{bidding.title}}</span></p>
        <p class="time">{{bidding.time}}</p>
      </div>
      <!-- 分页 -->
      <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage"/>
    </div>
  </div>
</template>

<script>
import {locationBiddingPaging} from "@/api/interfaceApi";
import page from "@/components/page/pages";

export default {
  name: "bidding",
  components:{page},
  data(){
    return{
      cid: 0,
      biddingData:[],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  props: {
    activeIndex: {
      type: String,
      default() {
        return '2'
      }
    },
    activeTabs: {
      type: Object,
      default() {
        return {
          epidemic_url: "",
          image: "",
          is_epidemic: 0,
          is_local: 0,
          name: "推荐",
          nid: '2',
          no: 0,
        };
      }
    },
    cityList: {
      type: Object,
      default() {
        return {
          id: 500000,
          lat: 29.533155,
          level: 1,
          lng: 106.504959,
          name: "重庆",
          pid: 0,
          short_name: "重庆"
        }
      }
    }
  },
  watch: {
    activeIndex: function (val, oldVal) {
      this.tablePage.currentPage = 1;
      this.getInfo();
    }
  },
  methods:{
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getInfo();
    },
    /*获取列表数据*/
    getInfo() {
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      locationBiddingPaging({
        page: this.tablePage.currentPage,
        province: this.cityList.id,
        time: "0",
        type: 0,
        uid: cid != 0 && cid != undefined ? cid : 0
      }).then(res => {
        if (res.code == 200) {
          window.scrollTo(0, 0);
          this.biddingData = res.content.data;
          this.tablePage.total = res.content.total;
        }
      })
    },
    /*查看详情*/
    details(row) {
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      let routeData = this.$router.resolve({
        name: "policyDetails",
        query: {
          id: row.id,
        },
        path: '/article/policyDetails',
      });
      window.open(routeData.href, '_blank')
    },
  },
  mounted() {
    this.getInfo();
  },
  beforeMount() {
    let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.cid = cid != 0 && cid != undefined ? cid : 0
  }
}
</script>

<style scoped lang="scss">
.bidding-container{
  .bidding-content{
    .bidding-info{
      display: flex;
      justify-content: space-between;
      .adRegions{
        font-size: 16px;
        color: #333333;
      }
      .title{
        font-size: 16px;
        color: #333333;
        position: absolute;
        width: 45%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .time{
        color: #AAAAAA;
        font-size: 16px;
      }
    }
  }
}
</style>